export * from './TextInput';
//# sourceMappingURL=index.js.map